// extracted by mini-css-extract-plugin
export default {"unpaidInvoices":"UnpaidInvoiceNotice_unpaidInvoices__JWyZV","unpaidInvoice":"UnpaidInvoiceNotice_unpaidInvoice__ZyRS6"};